<template>
  <v-dialog
    :max-width="maxWithProp"
    dark
    v-if="dialogChooseItem"
    v-model="dialogChooseItem"
    persistent
    transition="dialog-bottom-transition">
    <v-container fluid grid-list-sm>
      <v-toolbar dark>
        <v-toolbar-title class="headline">{{ $t(translation + '.chooseHeader') }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              dark
              v-bind="attrs"
              v-on="on"
              :loading="tableDataLoading"
              :disabled="tableDataLoading"
              class="mr-2"
              color="warning"
              @click="id ? readTableDataById(api,id) : refreshData(true, true)">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </template>
          <span>
              {{ $t('tooltips.refresh') }}
            </span>
        </v-tooltip>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              class="ml-2"
              v-bind="attrs"
              v-on="on"
              @click="closeChooseItemDialog">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
          <span>
              {{ $t('tooltips.close') }}
            </span>
        </v-tooltip>
      </v-toolbar>
      <v-spacer></v-spacer>
      <v-data-table
        dark
        :dense="true"
        :mobile-breakpoint="breakpoint"
        :page="page"
        :pageCount="numberOfPages"
        :headers="headers"
        :items="tableData"
        :options.sync="options"
        :items-per-page="itemsPerPage"
        :server-items-length="totalRows"
        :footer-props="{
        itemsPerPageOptions: itemsPerPageOptions,
        'items-per-page-text': $t('general.items_per_page'),
        'page-text': fromItem + '-' + toItem + ' ' + $t('general.of') + ' ' + totalRows
        }"
        :loading-text="$t('loading_data')"
        class="elevation-1 secondary white--text"
        :loading="tableDataLoading"
        @click:row="selectItemOnRowClick"
      >
        <!--<template v-slot:item.name="{ item }">-->
        <!--<v-chip :color="getColor(item.calories)" dark>{{ item.name }}</v-chip>-->
        <!--</template>-->
        <template v-slot:item.is_active="{ item }">
          <v-chip small
                  :class="{'error inactive-row white--text':(!item.is_active) , 'secondary white--text':(item.is_active)}">
            {{ item.is_active ? $t('active') : $t('not_active') }}
          </v-chip>
        </template>
        <!-------------------------------------  DETAILS EDIT DELETE  ----------------------------------------------->
        <template v-slot:item.actions="{ item }">
          <v-icon
            dark
            class="ma-0 py-2"
            :color="getIcon(item).color"
          >
            {{ getIcon(item).icon }}
          </v-icon>
        </template>
        <!----------------------------------- ## FILTERS ## ------------------------------------>
        <template v-slot:body.prepend>
          <tr style="height: 60px !important;">
            <th v-for="header in headers"
                :key="header.name"
                class="py-0 px-2 my-0 secondary white--text">
              <v-select
                dark
                dense
                hide-details
                v-if="header.name === 'active'"
                class="justify-center"
                v-model="filters[header.value]"
                @change="refreshData(true)"
                :items="activeObjects"
                item-value="value"
                item-text="text"
                style="padding: 0; margin-top: 2em !important; margin-bottom: -1em !important;  font-size: inherit; text-align: right !important;"
                label="Filter"
              />
              <v-text-field
                dark
                dense
                v-else-if="header.name !== 'actions'"
                v-model="filters[header.value]"
                @keyup.enter.native="refreshData(true)"
                label="Filter"
                :placeholder="header.text"
                filled
                hide-details
                style="padding: 0; font-size: inherit; text-align: right !important;"
                v-eager
                enterkeyhint="done"
              />
            </th>
          </tr>
        </template>
        <!-------------------------------- ## NO DATA ## ----------------------------------->
        <template v-slot:no-data>
          <div class="text-xs-center">
            <v-alert color="error" icon="mdi-alert-circle-outline">
              {{ errorMessage }}
            </v-alert>
          </div>
        </template>
      </v-data-table>
      <!---------------------------------- Snackbar  ----------------------------------------->
      <v-snackbar
        v-model="snackbar.show"
        :bottom=true
        :color="snackbar.color"
        :timeout="snackbar.timeout">
        {{ snackbar.text }}
        <v-btn dark text @click="snackbar.show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-snackbar>

      <v-card-actions class="primary">
        <v-btn
          class="error mr-2"
          dark
          :disabled="tableDataLoading"
          @click="closeChooseItemDialog()">
          {{ $t('close') }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          class="info ml-2"
          dark
          :disabled="tableDataLoading"
          @click="add()"
        >
          {{ $t('confirm') }}
        </v-btn>

      </v-card-actions>
    </v-container>
  </v-dialog>
</template>

<script>
import {
  addEmit,
  editEmit,
  findById,
  onDelete,
  readTableData,
  readTableDataById, readTableDataPost, readTableDataPostPagination,
  refresh,
  search
} from "../../statics/DataTableFunctions";
import axios from "axios";

export default {
  props: {
    maxWithProp: null,
    id: null,
    translation: null,
    items: '',
    api: '',
    showColumns: null,
    additionalParameters: null,
    headers: null,
    sortByColumn: null,
    singleSelect: {
      default: true,
      type: Boolean
    },
    preSelected: {
      default() {
        return []
      },
      type: Array
    },
    dialogChooseItem: ''
  },
  name: "ChooseItemDialog",
  data() {
    return {
      initLoad: true,
      rowSelected: null,
      selectedId: 0,
      selected: [],
      addedPartners: [],
      tableData: [],
      defaultActive: '',
      deleteLoadingId: -1,
      breakpoint: 0,
      page: 1,
      numberOfPages: 10,
      totalRows: 0,
      itemsPerPage: 10,
      itemsPerPageOptions: [
        10,
        // 20,
        // 30,
        // 50,
        // 100,
        // 200,
        // 500
      ],
      options: {
        sortBy: [
          this.sortByColumn ? this.sortByColumn : 'name'
        ],
        sortDesc: [
          false
        ]
      },
      dataForModal: {},
      addItemDialog: false,
      editItemDialog: false,
      tableDataLoading: false,
      filteredTableData: [],
      filters: {
        is_active: '',
      },
      errorMessage: this.$t('no_data'),
      snackbar: {
        color: 'success',
        show: false,
        text: '',
        timeout: 3000,
      },

    }
  },
  methods: {
    search,
    findById,
    refresh,
    onDelete,
    readTableDataPost,
    readTableDataPostPagination,
    readTableDataById,
    addEmit,
    editEmit,
    selectItemOnRowClick(item, row) {
      if (this.singleSelect) {
        this.select(item, row);
      } else {
        this.updateSelected(item, row);
      }
    },
    getIcon(item) {
      if (this.singleSelect ? item.id === this.selectedId : this.doesSelectedContainsItem(item)) {
        return {
          icon: 'mdi-checkbox-marked',
          color: '#ed1c24'
        };
      }
      return {
        icon: 'mdi-checkbox-blank-outline',
        color: '#fff'
      }
    },
    doesSelectedContainsItem(item) {
      return this.selected.filter(selectedObject => {
        return selectedObject.id === item.id;
      }).length > 0;
    },
    updateSelected(item, row) {
      if (!this.doesSelectedContainsItem(item)) {
        this.selected.push(item);
        row.select(true);
      } else {
        this.selected.splice(this.selected.findIndex(selectedObject => selectedObject.id === item.id), 1)
        row.select(false);
      }
    },
    findItemByID(id) {
      for (let i = 0; i < this.tableData.length; i++) {
        if (this.tableData[i].id === id) {
          return this.tableData[i];
        }
      }
      return null;
    },
    select(item, row) {
      if (this.selected === item || this.selectedId === item.id) {
        row.select(false)
        this.rowSelected = null;
        this.selected = null;
        this.selectedId = -1;
        return;
      }
      row.select(true);
      if (this.rowSelected) {
        this.rowSelected.select(false);
      }
      this.rowSelected = row;
      this.selected = item
      this.selectedId = item.id
    },
    add() {
      this.$emit('itemChosenEvent', this.selected);
      this.tableData = [];
      this.selected = [];
      this.selectedId = null;
      this.initLoad = true;
    },
    openEditDialog(item) {
      this.editItemDialog = true;
      this.dataForModal = item;
    },
    closeChooseItemDialog() {
      this.$emit('closeChooseItemDialog')
    },
    refreshData(resetPagination = false, resetFilters = false) {
      if (resetPagination) {
        this.options.page = 1;
        this.options.itemsPerPage = 10;
        this.isRefreshingData = true;
      }
      if (resetFilters) {
        Object.keys(this.filters).forEach(f => {
          this.filters[f] = ''
        });
      }
      this.readTableDataPostPagination(this.api, true, this.showColumns, {
        ...this.additionalParameters,
        filters: this.filters,
        options: this.options
      });
    }
  }
  ,
  computed: {
    fromItem() {
      return this.options.page === 1 ? 1 : (this.options.page - 1) * this.options.itemsPerPage + 1
    }
    ,
    toItem() {
      if (this.options.itemsPerPage > this.totalRows) {
        return this.totalRows;
      }
      if (this.options.page === 1) {
        return this.options.itemsPerPage
      }

      const toItems = this.options.page * this.options.itemsPerPage;

      if (toItems > this.totalRows) {
        return this.totalRows;
      }

      return toItems;
    }
    ,
    activeObjects() {
      return [
        {value: "", text: this.$t('all')},
        {value: 'true', text: this.$t('active')},
        {value: 'false', text: this.$t('not_active')},
      ]
    }
    ,
  }
  ,
  watch: {
    options: {
      handler() {
        if (!this.isRefreshingData) {
          this.refreshData()
        }
      }
      ,
      deep: true
    },
    dialogChooseItem: function (val) {
      if (val) {
        this.refreshData(true, true);
      }
    },
    tableData: function (val) {

      if (val && Array.isArray(val) && val.length > 0) {
        if (this.id && this.initLoad) {
          this.selected = this.findItemByID(this.id)
          this.selectedId = this.selected ? this.selected.id : -1;
          this.initLoad = false;
        }

        console.log(this.preSelected.length);
        if (this.preSelected.length > 0) {
          this.preSelected.forEach(preSelectedItem => {
            const foundItems = this.tableData.filter(item => item.id === preSelectedItem.id);
            if(foundItems.length > 0) {
              const item = foundItems[0];
              if(!this.doesSelectedContainsItem(item)) {
                this.selected.push(item);
              }
              // else {
              //   console.log('splice')
              //   this.selected.splice(this.selected.findIndex(selectedItem => selectedItem.id === item.id), 1);
              // }
            }
          })

        }
      }
    }
  }
}
</script>

<style>
tr.v-data-table__selected {
  background: #1f1f1f !important;
}
</style>
